/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      // magnific pop up for images
      $( '.gallery__image' ).magnificPopup( {
        type: 'image',
        focus: '.mfp-close',
        gallery: {
          enabled: true,
          arrowMarkup: '<button title="%title%" type="button" class="photo-gallery__arrow mfp-arrow mfp-arrow-%dir%"></button>',
        },
        image: {
          titleSrc: function( item ) {
            return $( item.img ).attr( 'alt' );
          },
        },
      } );

      const imagesTotal = $( '.gallery__image-card' ).length;
      const intialAmount = $( '.photo-gallery' ).attr( 'data-initial' );

      $( '.gallery__image-card' ).slice( 0, intialAmount ).show();

      $( '.photo-gallery__load' ).on( 'click', function() {
        $( '.gallery__image-card' ).slice( intialAmount, imagesTotal ).show();
        $( $( '.gallery__image-card' )[intialAmount] ).find( '.gallery__image' ).trigger( 'focus' );
        $( '.photo-gallery__load-container' ).addClass( 'hidden' );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'photo-gallery', COMPONENT );
} )( app );
